<template>
  <div class="article-share">
    <div>
      <a :href="twitterLink" data-testid="share-twitter">Share on X ↗</a>
      <a :href="linkedinLink" data-testid="share-linkedin">LinkedIn ↗</a>
    </div>
  </div>
</template>
<script setup lang="ts">
import type { Article } from '~/types/article'
const props = defineProps<{ blogInfo: Article }>()
const url = computed(() => `https://filiphric.com/${props.blogInfo.slug}`)
const twitterLink = computed(
  () =>
    `https://twitter.com/intent/tweet?${new URLSearchParams({ url: url.value, text: `I just read "${props.blogInfo.title}" by @filip_hric` })}`
)
const linkedinLink = computed(
  () => `https://www.linkedin.com/sharing/share-offsite/?${new URLSearchParams({ url: url.value })}`
)
</script>
